import React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter, Route, Routes, Navigate } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./views/lysto/hooks/queryClient";
import AuthLayout from "layouts/auth";
import AdminLayout from "layouts/admin";
import LandingLayout from "layouts/landing";
import PrivateRoute from "components/PrivateRoutes";
import routes from "./routes";
import "assets/css/App.css";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "theme/theme";
import AuthCallback from "./views/auth/components/AuthCallback";
import LogoutCallback from "./views/auth/components/LogoutCallback";
import DynamicRedirect from "./components/DynamicRedirect";

const root = createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <ChakraProvider theme={theme}>
      <React.StrictMode>
        <HashRouter>
          <Routes>
            <Route
              path="/"
              element={
                <LandingLayout
                  routes={routes.filter((route) => route.layout === "/")}
                />
              }
            />
            <Route path="/auth" element={<AuthLayout />}>
              <Route path="callback" element={<AuthCallback />} />
              <Route path="logout" element={<LogoutCallback />} />
              <Route
                path="*"
                element={<Navigate to="/auth/callback" replace />}
              />
            </Route>
            {/* Add a direct route for /callback to handle Auth0 redirects */}
            <Route path="/callback" element={<AuthCallback />} />

            {/* Redirect old landing page route to root */}
            <Route path="/landing/*" element={<Navigate to="/" replace />} />

            {/* Redirect /admin to appropriate route based on visible routes */}
            <Route path="/admin" element={<DynamicRedirect />} />

            <Route
              path="/admin/*"
              element={
                <PrivateRoute>
                  <AdminLayout />
                </PrivateRoute>
              }
            />

            {/* Explicitly handle the privacy and terms routes */}
            <Route
              path="/privacy"
              element={
                <LandingLayout
                  routes={routes
                    .filter((route) => route.name === "PrivacyPolicy")
                    .map((route) => ({ ...route, path: "" }))}
                />
              }
            />

            <Route
              path="/terms"
              element={
                <LandingLayout
                  routes={routes
                    .filter((route) => route.name === "TermsOfService")
                    .map((route) => ({ ...route, path: "" }))}
                />
              }
            />

            {/* Redirect all unknown routes to the dynamic default path */}
            <Route path="*" element={<DynamicRedirect />} />
          </Routes>
        </HashRouter>
      </React.StrictMode>
    </ChakraProvider>
  </QueryClientProvider>
);
